export const APP_ROUTES = {
  SPLASH: "/",
  PRIVACY: "/privacy",
  FAQ: "/faq",
  TERMS: "/terms",
  BLOG: "/blog",
  BLOG_POST: "/blog/:slug",
  ABOUT: "/about",
  RESOURCES: "/resources",
} as const;
